const ROGERS_SINGLE_VARIANTS = [
    {
        objectName: 'SUPPORT_ROGERS_SINGLE_SMALL',
        maxTopWidth: 55,
        sizing: {
            width: {
                scaleZero: 25,
                scaleOne: 35
            },
            length: {
                scaleZero: 14,
                scaleOne: 17.5
            },
            scale: {
                scaleZero: 25,
                scaleOne: 37.5
            },
            baseThickness: 9,
            baseThicknessScaleOne: 16,
            baseThicknessCenterY: 15.5,
            baseThicknessCenterYScaleOne: 15.5
        }
    },
    {
        objectName: 'SUPPORT_ROGERS_SINGLE_MEDIUM',
        maxTopWidth: 75,
        sizing: {
            width: {
                scaleZero: 25.36,
                scaleOne: 35.51
            },
            length: {
                scaleZero: 14.18,
                scaleOne: 17.73
            },
            scale: {
                scaleZero: 25.36,
                scaleOne: 39.76
            },
            baseThickness: 11.0,
            baseThicknessScaleOne: 19.25,
            baseThicknessCenterY: 15.5,
            baseThicknessCenterYScaleOne: 15.5
        }
    },
    {
        objectName: 'SUPPORT_ROGERS_SINGLE_LARGE',
        maxTopWidth: Infinity,
        sizing: {
            width: {
                scaleZero: 40,
                scaleOne: 50
            },
            length: {
                scaleZero: 14,
                scaleOne: 17.5
            },
            scale: {
                scaleZero: 40,
                scaleOne: 60
            },
            baseThickness: 14.0,
            baseThicknessScaleOne: 24.5,
            baseThicknessCenterY: 15.5,
            baseThicknessCenterYScaleOne: 15.5
        }
    }
];
export function getRogersSingleVariant(topWidth, useMediumMinimum = false) {
    const variants = useMediumMinimum ? ROGERS_SINGLE_VARIANTS.slice(1) : ROGERS_SINGLE_VARIANTS;
    return variants.find((v)=>topWidth <= v.maxTopWidth) ?? ROGERS_SINGLE_VARIANTS[2];
}

//# sourceMappingURL=rogers-data.js.map